// ============================================================================
// KMP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'kmp',
  name: 'KMP',
  category: 'Strings',
  complexity: {
    time: 'O(N + M)',
    space: 'O(M)'
  },
  description: 'Knuth-Morris-Pratt algorithm for pattern matching in strings. It preprocesses the pattern to create a partial match table (failure function) that allows skipping unnecessary comparisons, achieving linear time complexity.'
};
